import { FormularioNovoCliente } from "../../components/Configuracoes/FormularioCliente"

export const NewClient = () => {
  return (
    <FormularioNovoCliente />
  )
}